import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ListIcon from '@material-ui/icons/List';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { withRouter } from 'react-router-dom';
import TopBar from '../topBar/topBar';
import authActions from '../../actions/auth/auth';
import './loggedInContainer.less';

class LoggedInContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
    };
  }

  openDrawer = () => {
    this.setState({ isDrawerOpen: true });
  }

  hideDrawer = () => {
    this.setState({ isDrawerOpen: false });
  }

  navigateTo = to => {
    const { history } = this.props;
    if (history.location.pathname === to) {
      return;
    }

    history.push(to);
  }

  logOut = () => {
    const { logOut } = this.props;
    logOut();
    this.navigateTo('/');
  }

  renderDrawer = () => {
    const { isAdmin } = this.props;

    return (
      <div>
        <Divider />
        <List>
          <ListItem button key="create-order" onClick={() => this.navigateTo('/create-order')}>
            <ListItemIcon>
              <ShoppingCartIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              className="order-menu-item"
              primary="Zamów"
              secondary="Złóż zamówienie"
            />
          </ListItem>
          <ListItem button key="my-orders" onClick={() => this.navigateTo('/my-orders')}>
            <ListItemIcon>
              <ListIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              className="order-menu-item"
              primary="Moje zamówienia"
              secondary="Lista złożonych zamówień"
            />
          </ListItem>
          <ListItem button key="logout" onClick={this.logOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Wyloguj" />
          </ListItem>
        </List>

        {isAdmin && (
          <div>
            <Divider />
            <List>
              <div className="admin-panel-label">
                <Typography variant="overline">
                  Panel Sprzedawcy
                </Typography>
              </div>
              <ListItem button key="create-product" onClick={() => this.navigateTo('/manage-products')}>
                <ListItemText primary="Dodaj / usuń produkt" />
              </ListItem>
              <ListItem button key="orders-list" onClick={() => this.navigateTo('/orders-list')}>
                <ListItemText primary="Lista zamówień" />
              </ListItem>
              <ListItem button key="realized-orders-list" onClick={() => this.navigateTo('/realized-orders-list')}>
                <ListItemText primary="Lista zrealizowanych zamówień" />
              </ListItem>
            </List>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { children } = this.props;
    const { isDrawerOpen } = this.state;

    return (
      <div>
        {/* desktop */}
        <Hidden xsDown implementation="css" className="logged-in-container logged-in-container-desktop">
          <Drawer
            open
            variant="persistent"
            className="navigation-drawer"
          >
            {this.renderDrawer()}
          </Drawer>
          <div className="content-container">
            <TopBar />
            <Container className="page-container" maxWidth={false}>
              {children}
            </Container>
          </div>
        </Hidden>

        {/* mobile */}
        <Hidden smUp implementation="css" className="logged-in-container">
          <Drawer
            open={isDrawerOpen}
            className="navigation-drawer"
            onBackdropClick={this.hideDrawer}
          >
            {this.renderDrawer()}
          </Drawer>
          <div className="content-container">
            <TopBar openDrawer={this.openDrawer} />
            <Container className="page-container">
              {children}
            </Container>
          </div>
        </Hidden>
      </div>
    );
  }
}

LoggedInContainer.propTypes = {
  children: PropTypes.node,
  logOut: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  }).isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

LoggedInContainer.defaultProps = {
  children: undefined,
};

const bindActions = {
  logOut: authActions.logOut,
};

const mapStateToProps = state => ({
  isAdmin: state.auth.roles.indexOf('Admin') !== -1,
});

export default withRouter(
  connect(mapStateToProps, bindActions)(LoggedInContainer),
);
